/* eslint-disable no-debugger */
import { Fragment } from 'react';

import useProfilePublicAttachmentDetail from './UseProfilePublicAttachmentDetail';

import NTAttachmentForm from '../../../components/forms/nationalTeamAttachment/NTAttachmentForm';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import { LOADING_MSG, SAVING_MSG } from '@usas/ui-web/utils/Constants';

const ProfilePublicAttachmentDetail = () => {
  const {
    basePersonState,
    isSaving,
    isLoading,
    attachmentObj,
    nationalTeamAttachmentState,
    onCancelClicked,
    onDownloadFileClicked,
    onSubmitAttachmentForm
  } = useProfilePublicAttachmentDetail();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{attachmentObj ? 'Edit Attachment' : 'Add Attachment'}</Headings.H3>
        </div>
      </div>
      {attachmentObj !== undefined && (
        <NTAttachmentForm
          basePersonState={basePersonState}
          attachmentObj={attachmentObj}
          submitButtonText={attachmentObj ? 'Save' : 'Add Attachment'}
          uploadedAttachments={nationalTeamAttachmentState?.arrayData.map(item => ({
            id: item.personNationalAttachmentFileTypeId
          })) || []}
          onSubmitFormCallback={onSubmitAttachmentForm}
          onSecondaryButtonClicked={onCancelClicked}
          onDownloadUploadedFileClicked={onDownloadFileClicked}
          isPublicFileType={true} />
      )}
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default ProfilePublicAttachmentDetail;